module.exports = {
	"base": {
		"welcome": "Witamy w Mulligans, %{name}!",
		"user": "Informacje o użytkowniku",
		"devices": "Urządzenia",
		"refunds": "Zwroty",
		"resources": "Zasoby",
		"transactions": "Transakcje i zwroty",
		"email": "Adres e-mail",
		"password": "Haslo",
		"save": "Zapisz",
		"sign-out": "Wyloguj",
		"cancel": "Anuluj",
		"close": "Zamknij",
		"learn-more": "Dowiedz się więcej",
		"required": "Wymagane",
		"support": "Wsparcie",
		"bookshelf": "Biblioteczka",
		"launch": "Uruchomienie",
		"download": "Pobierz",
		"details": "Szczegóły",
		"cannot-be-blank": "%{field} nie może być puste.",
		"saving": "Zapisywanie...",
		"done": "Gotowe",
		"failed": "Nie powiodło się",
		"copy": "Kopiuj"
	},
	"signin": {
		"login-failure": "Hasło lub e-mail są nieprawidłowe",
		"welcome-large": "Witamy w <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Zaloguj",
		"forgot-password": "Nie pamiętam hasła",
		"new-to-vst": "Nie znasz jeszcze %{brand}?",
		"create-account": "Utwórz konto",
		"signing-in": "Trwa logowanie...",
		"signin-failed": "Błąd logowania"
	},
	"transactions": {
		"price": "Cena",
		"excluded": "(Bez podatku)",
		"quantity": "Ilość",
		"confirmation#": "Nr potwierdzenia",
		"payment": "Płatność",
		"purchased": "Zakupione",
		"purchase-details": "Szczegóły zakupu",
		"subtotal": "Suma składowa",
		"total": "Łącznie",
		"tax": "Podatek",
		"loading": "Właśnie wczytujemy twoje transakcje...",
		"no-purchases": "Brak zakupów.",
		"seller-vat": "VAT sprzedawcy",
		"total-vat": "%{vat} zapłacony w sumie",
		"portion": "%{subTax} Podatek %{rate}%",
		"vat-disclosure": "Cena zawiera %{vat}",
		"purchases": "Zakupy",
		"refunded-items": "Zwrócone pozycje",
		"book-title": "Tytuł książki",
		"refund-details": "Informacje o zwrotach",
		"print-receipt": "Drukuj rachunek",
		"request-refund": "Prześlij żądanie zwrotu",
		"expired": "Wygasła",
		"expires-in": "Wygasa %{date}",
		"details-refund": "Szczegóły i zwrot",
		"modal": {
			"cant-refund-title": "Zwrot niedostępny",
			"cant-refund": "Nie można dokonać zwrotu za książkę z co najmniej jednego powodu.",
			"cant-refund-1": "Przejrzano zbyt duży fragment książki.",
			"cant-refund-2": "Minęło ponad 14 dni od daty zakupu.",
			"cant-refund-3": "Odkryto kod zasobów online.",
			"cant-refund-4": "Już wcześniej uzyskano zwrot za książkę.",
			"cant-refund-5": "Wszystkie kody zostały już zrealizowane i/lub zwrócone.",
			"cant-refund-6": "Minęło ponad 30 dni od daty zakupu.",
			"cant-refund-support": "Jeśli nadal nie masz pewności, jak działa polityka zwrotów %{brand}, skontaktuj się z <a href='%{support_url}' target='_blank'>działem pomocy</a>."
		},
		"license": {
			"perpetual": "Dostęp online nie wygasa",
			"days": "Okres dostępu w dniach: %{days}"
		}
	},
	"devices": {
		"description": "W %{brand} można jednocześnie aktywować komputery <span>%{desktop}</span> oraz urządzenia przenośne <span>%{mobile}</span> .",
		"loading": "Mamy twoje urządzenia :)",
		"no-active": "Brak aktywnych urządzeń.",
		"deactivate": "Dezaktywuj"
	},
	"user": {
		"personal-information": "Informacje osobiste",
		"security-information": "Informacje dot. bezpieczeństwa",
		"notifications": "Powiadomienia",
		"first-name": "Imie",
		"last-name": "Nazwisko",
		"change-password-title": "Zmień hasło",
		"current-password": "Bieżące hasło",
		"new-password": "Nowe hasło",
		"security-password": "Haslo",
		"confirm-new-password": "Potwierdź nowe hasło",
		"security-question": "Pytanie zabezpieczające",
		"security-info-change": "Zmień",
		"question": "Pytanie",
		"answer": "Odpowiedź",
		"notifications-text": "Proszę o wysyłanie okresowych wiadomości e-mail z aktualizacjami dotyczącymi aktywności na moim koncie i produktów oraz z ofertami specjalnymi.",
		"loading": "Reksio poszedł szukać twoich danych logowania, poczekaj chwilę 🐶",
		"change-password-text": "Hasło musi zawierać co najmniej 8 znaków, wielką literę, małą literę i znak specjalny.",
		"email-locked": "Zablokowany adres e-mail",
		"email-locked-description": "Nie masz dostępu, aby zmienić swój adres e-mail.",
		"email-locked-more": "Skontaktuj się z administratorem.",
		"security-question6": "Jaki jest twój ulubiony sport?",
		"security-question7": "Jaki jest twój ulubiony smak lodów?",
		"security-question8": "Jak się nazywa twoje zwierzę?",
		"security-question9": "Jako dziecko kim chciałeś być w przyszłości?",
		"security-question10": "Jak się nazywał twój ulubiony nauczyciel?",
		"new-password-failure": "Hasło nie spełnia wymogów",
		"confirm-password-failure": "Hasła muszą być zgodne",
		"new-password-tooltip": "Musi zawierać co najmniej 8 znaków, wielką literę, małą literę i znak specjalny.",
		"enter-valid-email": "Podaj prawidłowy adres e-mail.",
		"password-cannot-be-same": "Hasło nie może być takie samo, jak poprzednie hasło",
		"incorrect-password": "Niepoprawne hasło",
		"complete-account": "Musisz <a href='%{href}'>uzupełnić konto</a>.",
		"completing-allows": "Po uzupełnieniu konta możesz czytać książki offline za pomocą aplikacji mobilnej i udostępniać notatki oraz zaznaczenia znajomym.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Dodatki",
		"access-codes": "Kody dostępu",
		"print-on-demand": "Druk na żądanie",
		"check-pod": "Sprawdź opcje wydruku swoich książek u wydawcy.",
		"check-now": "Sprawdź teraz",
		"loading": "Poczekaj, aktualizujemy twoje zasoby.",
		"in": "w",
		"access-code-intro": "Kod dostępu jest hasłem służącym do korzystania z zawartości kursu online. Po poznaniu kodu pozycji nie możesz go zwrócić. Dodatkowe instrukcje dotyczące używania kodów dostępowych można uzyskać, odwiedzając <a href='%{support_url}' target='_blank'>stronę pomocy</a>.",
		"expires": "Wygasa",
		"expiration-message": "Zawiera instrukcje dotyczące korzystania z kod dostępu.",
		"copy-fail": "Nie można skopiować. Zaznacz kod ręcznie i skopiuj go.",
		"launch-site": "Witryna uruchamiania",
		"launch-book": "Uruchom książkę",
		"reveal-code": "Ujawnij kod",
		"no-resources": "Brak zasobów.",
		"no-access-codes": "Brak kodów dostępu.",
		"no-ancillaries": "Brak pomocy dla tego tytułu",
		"name": "Nazwisko",
		"type": "Typ",
		"size": "Wielkość",
		"download-all": "Pobierz wszystko",
		"back": "Wróć do zasobów"
	},
	"refunds": {
		"states": {
			"refunded": "Zwrócono",
			"unavailable": "Nie można zwrócić"
		},
		"reasons": {
			"dropped": "Nie korzystam z kursu",
			"wrong": "Książka nieodpowiednia dla mojego kursu",
			"print": "Wybrano wersję drukowaną",
			"missing": "Książka nie zawiera wszystkiego, czego potrzebuję podczas kursu (np. CD, dostęp internetowy, filmy)",
			"other": "Inne"
		},
		"bulk": {
			"policy": "Kliknięcie poniższego przycisku &quot;Ukończ zwrot&quot; oznacza, że wyrażam zgodę na zastosowanie się w przypadku %{brand} <a href='%{policy_url}' target='_blank'>do polityki zwrotów tej marki</a>.",
			"complete": "Ukończ zwrot",
			"view-details": "Szczegółowe informacje o zwrotach",
			"success": "Wysłano prośbę o zwrot. Poczekaj 48 godzin na jej przetworzenie.",
			"failure": "Wystąpił problem. Zwrot nie został zrealizowany.",
			"retry": "Spróbuj ponownie",
			"support": "Kontakt z pomocą",
			"available-codes": "Dostępne kody",
			"codes-selected": "Wybrane kody",
			"download": "Pobierz kody",
			"partially-refunded": "Zwrot częściowy",
			"pick-one": "Wybierz co najmniej jeden kod, aby dokonać zwrotu"
		},
		"refund": "Zwrot",
		"all": "Zwrócić wszystko?",
		"missing-reason": "Aby kontynuować, wybierz przyczynę",
		"missing-elaboration": "Opisz",
		"policy": "Klikając poniższy przycisk Ukończ wniosek o zwrot, rozumiem, że w przypadku ponownego zakupu tego podręcznika elektronicznego %{brand} eTextbook, nie będę mieć możliwości uzyskania za niego zwrotu. Wyświetl pełną politykę zwrotów.",
		"refunded": "Zwrócono",
		"sorry": "Przykro nam, że zakup nie spełnia oczekiwań.",
		"error": "Wystąpił problem",
		"error-explain": "Nie można przetworzyć zwrotu. Spróbuj ponownie.",
		"why": "Dlaczego?",
		"no-refunds": "Brak zwróconych pozycji.",
		"select-codes": "Wybierz kody do dokonania zwrotu:",
		"number": "Ile?",
		"back": "Wróć do zwrotów"
	},
	"purchases": {
		"back": "Wróć do zakupów"
	},
	"global-bar": {
		"account": "Ustawienia konta"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/pl.json
 ** module id = 994
 ** module chunks = 0
 **/